export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Incoming',
    i18nKey: 'INCOMING',
  },
  {
    id: 'outgoing',
    name: 'Outgoing',
    i18nKey: 'OUTGOING',
  },
];

export const CONTACT_TYPE_CONDITION_VALUES = [
  {
    id: 'visitor',
    name: 'Visitor',
    i18nKey: 'VISITOR',
  },
  {
    id: 'lead',
    name: 'Lead',
    i18nKey: 'LEAD',
  },
  {
    id: 'customer',
    name: 'Customer',
    i18nKey: 'CUSTOMER',
  },
];

export const BUSINESS_HOURS_CONDITION_VALUES = [
  {
    id: 'inside',
    name: 'Inside business hours',
    i18nKey: 'INSIDE',
  },
  {
    id: 'outside',
    name: 'Outside business hours',
    i18nKey: 'OUTSIDE',
  },
];

export const CHANNEL_TYPE_CONDITION_VALUES = [
  {
    id: 'Channel::WebWidget',
    name: 'Web Widget',
    i18nKey: 'WEB_WIDGET',
  },
  {
    id: 'Channel::Api',
    name: 'API',
    i18nKey: 'API',
  },
  {
    id: 'Channel::Email',
    name: 'Email',
    i18nKey: 'EMAIL',
  },
  {
    id: 'Channel::Whatsapp',
    name: 'WhatsApp',
    i18nKey: 'WHATSAPP',
  },
  {
    id: 'Channel::TwilioSms',
    name: 'Twilio SMS',
    i18nKey: 'TWILIO_SMS',
  },
  {
    id: 'Channel::Sms',
    name: 'SMS',
    i18nKey: 'SMS',
  },
  {
    id: 'Channel::Telegram',
    name: 'Telegram',
    i18nKey: 'TELEGRAM',
  },
  {
    id: 'Channel::TwitterProfile',
    name: 'Twitter',
    i18nKey: 'TWITTER',
  },
  {
    id: 'Channel::FacebookPage',
    name: 'Facebook',
    i18nKey: 'FACEBOOK',
  },
  {
    id: 'Channel::Instagram',
    name: 'Instagram',
    i18nKey: 'INSTAGRAM',
  },
  {
    id: 'Channel::Line',
    name: 'LINE',
    i18nKey: 'LINE',
  },
];

export const PRIORITY_CONDITION_VALUES = [
  {
    id: 'nil',
    name: 'None',
    i18nKey: 'NONE',
  },
  {
    id: 'low',
    name: 'Low',
    i18nKey: 'LOW',
  },
  {
    id: 'medium',
    name: 'Medium',
    i18nKey: 'MEDIUM',
  },
  {
    id: 'high',
    name: 'High',
    i18nKey: 'HIGH',
  },
  {
    id: 'urgent',
    name: 'Urgent',
    i18nKey: 'URGENT',
  },
];
